export default {
  resource:{
    zh: {
      scode: "编号",
      sname: "名称",
      formula:"公式",
      remark:	"备注",
      nullId:"编号不能为空！",
      nullName:"名称不能为空！",
      alExists:"编号或名称已经存在，请检查！",
      nameExist:"部门已经存在，请检查！"
    }

  },
  delConf:["sname"],
  delKeys:["autoid"],
  params: {
    scode:{
      key: "scode",
      data: null,
      method: "Equal",
      type: "text"
    },
    sname:{
      key: "sname",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "scode","sname", "formula","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"autoid",
  defaultSortOrder:"asc",
  sortName: "autoid",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "salaryFormula/",
  autoId: "autoid"

}
